import React from 'react';
import '../styles/DocsYouTube.css';

const DocsYouTube = () => {
    return (
        <div className="section docs-youtube-section">
            <div className="container">
                <div className="dy-grid">
                    {/* Docs Section */}
                    <div className="dy-card docs-card">
                        <div className="dy-icon">
                            <i className="fab fa-github"></i>
                        </div>
                        <h2 className="dy-title">Documentation</h2>
                        <p className="dy-desc">
                            Explore our open-source projects, including PLC firmware, sensor libraries, and ESP32-S3 examples.
                        </p>
                        <a href="https://github.com/kdi6033" target="_blank" rel="noreferrer" className="btn btn-outline dy-btn">
                            Visit GitHub
                        </a>
                    </div>

                    {/* YouTube Section */}
                    <div className="dy-card youtube-card">
                        <div className="dy-icon">
                            <i className="fab fa-youtube"></i>
                        </div>
                        <h2 className="dy-title">YouTube Channel</h2>
                        <p className="dy-desc">
                            Watch over 800+ videos on IoT, AI, and Automation. Learn from expert tutorials and demos.
                        </p>
                        <a href="https://www.youtube.com/@i2r-link" target="_blank" rel="noreferrer" className="btn btn-primary dy-btn">
                            Watch Now
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocsYouTube;
